/**
 * Price Component
 *
 * This component is used to display the price of a product or variant in a formatted manner.
 * It handles cases where the product has a discounted price (compare at price) and shows
 * both the original and discounted prices accordingly.
 *
 * Props:
 * - product: The product object containing details about the product.
 * - currentVariant: The current variant object.
 * - discountPromo = Discount promo text which should come from the metafield promo_badge. Default is null.
 */

import { h, Fragment } from 'preact';
import { formatMoney } from 'utils/storefront/format-resource';

const Price = ({ product, currentVariant, discountPromo = null, isProductForm = false }) => {
  const { price, compareAtPrice } = window.getProductPrice(currentVariant, product.tags);

  const isBundleTag = product.tags?.find((tag) => tag?.startsWith('is_bundle::'));
  const bundleMsrpTag = product.tags?.find((tag) => tag?.startsWith('bundle_MSRP::'));
  const isBundle = isBundleTag ? isBundleTag.split('::')[1] === 'True' : null;
  const bundleMsrp = bundleMsrpTag ? bundleMsrpTag.split('::')[1] : null;

  return (
    <div className="flex items-baseline gap-6">
      {currentVariant && (
        <>
          {parseFloat(compareAtPrice.amount) > parseFloat(price.amount) && (
            <>
              <span className="body-14-med md:body-16-med text-faded-black">MSRP: </span>
              <span className={`body-14 text-secondary ${isProductForm ? 'md:body-16' : ''} `}>
                <s>{formatMoney(compareAtPrice)}</s>
              </span>
            </>
          )}

          {/* {isBundle && <span className="body-14-med md:body-16-med text-faded-black">MSRP: </span>} */}

          <span
            className={`body-14 text-secondary ${isProductForm ? 'md:body-16' : ''} ${parseFloat(compareAtPrice.amount) > parseFloat(price.amount) ? '!text-red' : ''} ${isBundle ? '!font-weight-bold !text-danube-blue' : ''}`}
          >
            {formatMoney(price)}
          </span>

          {isBundle && (
            <span className={`body-14 text-secondary ${isProductForm ? 'md:body-16' : ''} `}>
              <s>{bundleMsrp}</s>
            </span>
          )}

          {discountPromo && (
            <span
              className="leading-14 body-12-med rounded-full px-12 py-4"
              style={{
                backgroundColor: discountPromo.background_color,
                color: discountPromo.copy_color,
              }}
            >
              {discountPromo.copy}
            </span>
          )}
        </>
      )}
    </div>
  );
};

export default Price;
